import { mutationOptions } from "@tanstack/react-query";
import { tuyau } from "@/config/tuyau";
import { Periods } from "@hometoq/backend/enums";

export const customRequestMutations = {
  create: () =>
    mutationOptions({
      mutationFn: async (payload: {
        type: "DOMICILE" | "DEMEURE";
        date: string;
        period: Periods;
        city: string;
        guests: number;
        budget: number;
        preferences?: string;
        restrictions?: string;
        message?: string;
        name: string;
        email: string;
        phone: string;
      }) => await tuyau.customRequests.store({ body: payload }),
    }),
};
